module.exports = __webpack_public_path__ + "assets/img/bp2.6b133a62.png";